'use strict';

/**
 *
 * @name: ecommerce
 *
 */

import _get from 'lodash.get'

import DirectiveTemplate from './nn-ecommerce.directive.html';
import './nn-ecommerce.directive.scss';

function eCommerceDirective($stateParams, brandAnalytics) {

  'ngInject';

  return {
    restrict: 'A',
    template: DirectiveTemplate,
    scope: {
      content: '&',
      loaded: '='
    },
    link: function(scope, $element) {


      /*
      *
      * @CONFIG
      *
      */

      scope.item = scope.content();
      scope.brandAnalytics = brandAnalytics;

      scope.toEcommerce = (name,ecomerceItem)=>{
        window._hmt.push(
          [
          '_trackEvent',
          '组件', 'click',
          `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`
          ]
        );
        brandAnalytics.ecommerce(name,ecomerceItem.url)
      }
      scope.brandName = $stateParams.displayName;
      scope.ecomerceItem = _get(scope, 'item.jsonData.sources[0]')

      /*
      *
      * @PUBLIC
      *
      */


      /*
      *
      * @PRIVATE
      *
      */

      function _terminate() {
        scope.$destroy();
        $element.find('*').remove();
        $element.remove();
      }

      /*
      *
      * @INIT
      *
      */

      if (!scope.ecomerceItem) {
        return _terminate();
      }

    }
  };
}

export default eCommerceDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-ecommerce/nn-ecommerce.directive.js